import * as React from 'react'
import {ReactElement, ReactNode} from 'react'
import styled from 'styled-components'
import {Colors} from '../../styledComponents/Constants'
import {Nullable} from '../../app/TypeHelpers'
import {ADMINISTORATOR_MODE} from '../../CodeMaster'
import {StyledLink} from '../../styledComponents/adminPage/Links'
import {Box, ClickAwayListener} from '@mui/material'
import {LoginUserInfo} from './AdminHeaderAreaComponent'
import {FlexGrowContent, RowFlexContainer} from '../../styledComponents/FlexComponents'
import {
    ADMIN_HEADER_HEIGHT,
    AdminHeaderArea,
    AdminHeaderLogo,
    AdminHeaderShadow,
    AdminHeaderShadowCss,
    ChangeModeButtons,
    ChangeModePanelButton,
    ManualLink,
    PanelContainer,
    ResidentlLink,
    SelectedModeInfo,
    UserInfo,
    UserInfoPanelButton,
    ViewingCondominium,
    ViewingCondominiumGroup,
} from './AdminHeaderAreaParts'
import NatAdminMenuMasterComponentPc
    from '../../__NoAutomatedTests/components/menuMaster/admin/NatAdminMenuMasterComponentPc'
import {AsyncCommunicationProps, withAsyncCommunication} from '../shared/hoc/withAsyncCommunication'
import NatMenuMasterRepo from '../../__NoAutomatedTests/components/menuMaster/repository/NatMenuMasterRepo'
import EventEmitterExAdmin from '../shared/pageBaseComponents/EventEmitterExAdmin'
import {RouterPageProps} from '../shared/RouterPropsInjector'

interface Props {
    loginedFlg: boolean
    menuMasterRepo: NatMenuMasterRepo
    eventEmitter: EventEmitterExAdmin

    mode: Nullable<string>
    selectedCondominiumName: Nullable<string>
    hasValidSubCondominiumGroup: boolean
    loginUserInfo: LoginUserInfo

    handleClickAllMode: () => void
    handleClickCondominiumMode: () => void
    handleLogoutClick: () => void
    handleClickCondominiumGroupSwitchingLink: () => void
    handleChangeLoginSiteToResidentButtonClick: () => void
}

interface States {
    openedPanel: 'mode' | 'user' | false
}

class AdminHeaderAreaComponentPc extends React.Component<Props & AsyncCommunicationProps & RouterPageProps, States> {
    constructor(props: Props & AsyncCommunicationProps & RouterPageProps) {
        super(props)
        this.state = {
            openedPanel: false,
        }
    }

    closePanel = () => {
        this.setState({openedPanel: false})
    }

    changeOpenedPanel = (panel: 'mode' | 'user') => {
        if (this.state.openedPanel === panel) {
            this.closePanel()
        } else {
            this.setState({openedPanel: panel})
        }
    }

    handleClickChangeModePanelButton = () => {
        this.changeOpenedPanel('mode')
    }

    handleClickAllMode = () => {
        this.closePanel()
        this.props.handleClickAllMode()
    }

    handleClickCondominiumMode = () => {
        this.closePanel()
        this.props.handleClickCondominiumMode()
    }

    handleClickCondominiumGroupSwitchingLink = () => {
        this.closePanel()
        this.props.handleClickCondominiumGroupSwitchingLink()
    }

    handleClickUserInfoPanelButton = () => {
        this.changeOpenedPanel('user')
    }

    handleClickChangeLoginSiteToResidentButton = () => {
        this.closePanel()
        this.props.handleChangeLoginSiteToResidentButtonClick()
    }

    handleClickLogout = () => {
        this.closePanel()
        this.props.handleLogoutClick()
    }

    renderChangeModePanel(): ReactNode {
        if (!this.props.loginUserInfo.isBelongCondominiumGroup) {
            return null
        }

        const {openedPanel} = this.state
        const allMode = this.props.mode === ADMINISTORATOR_MODE.ALL.value
        const isOpen = openedPanel === 'mode'

        return <>
            <PanelContainer $panelOpened={isOpen}>
                <ChangeModePanelButton
                    panelOpened={isOpen}
                    onClick={this.handleClickChangeModePanelButton}
                />
                <Panel $open={isOpen} $width={'432px'} id={'panel-mode'}>
                    <ChangeModeButtons
                        allMode={allMode}
                        handleClickAllMode={this.handleClickAllMode}
                        handleClickCondominiumMode={this.handleClickCondominiumMode}
                    />
                    <ViewingCondominiumGroup
                        loginUserCondominiumGroupName={this.props.loginUserInfo.loginUserCondominiumGroupName}
                        hasValidSubCondominiumGroup={this.props.hasValidSubCondominiumGroup}
                        handleClickCondominiumGroupSwitchingLink={this.handleClickCondominiumGroupSwitchingLink}
                    />
                    {!allMode &&
                        <ViewingCondominium
                            selectedCondominiumName={this.props.selectedCondominiumName}
                            handleClickCondominiumSwitchingLink={this.handleClickCondominiumMode}
                        />
                    }
                </Panel>
            </PanelContainer>
        </>
    }

    renderUserInfoPanel(): ReactNode {
        const {openedPanel} = this.state
        const {roleName, loginUserAdminFamilyName, loginUserAdminFirstName} = this.props.loginUserInfo
        const isOpen = openedPanel === 'user'

        return <>
            <PanelContainer $panelOpened={isOpen}>
                <UserInfoPanelButton
                    panelOpened={isOpen}
                    onClick={this.handleClickUserInfoPanelButton}
                />
                <Panel $open={isOpen} $width={'376px'} id={'panel-user'}>
                    <UserInfo
                        roleName={roleName}
                        loginUserAdminFamilyName={loginUserAdminFamilyName}
                        loginUserAdminFirstName={loginUserAdminFirstName}
                    />
                    <ManualLink roleId={this.props.loginUserInfo.roleId}/>
                    <ResidentlLink
                        handleChangeLoginSiteToResidentButtonClick=
                            {this.handleClickChangeLoginSiteToResidentButton}
                    />
                    <StyledLink onClick={this.handleClickLogout}>
                        ログアウト
                    </StyledLink>
                </Panel>
            </PanelContainer>
        </>
    }

    render(): ReactElement {
        const {loginUserCondominiumGroupName, isBelongCondominiumGroup} = this.props.loginUserInfo
        const {openedPanel} = this.state
        const allMode = this.props.mode === ADMINISTORATOR_MODE.ALL.value

        if (!this.props.loginedFlg) {
            return <>
                <AdminHeaderShadow>
                    <AdminHeaderArea>
                        <Box width={'24px'}/>
                        <AdminHeaderLogo/>
                    </AdminHeaderArea>
                </AdminHeaderShadow>
            </>
        }

        return <>
            <AdminHeaderShadow>
                <AdminHeaderArea>
                    <Box width={'24px'}/>
                    <AdminHeaderLogo/>
                    <Box width={'32px'}/>
                    <SelectedModeInfo
                        loginUserCondominiumGroupName={loginUserCondominiumGroupName}
                        selectedCondominiumName={this.props.selectedCondominiumName}
                        allMode={allMode}
                        spMode={false}
                        isBelongCondominiumGroup={isBelongCondominiumGroup}
                    />
                    <FlexGrowContent/>
                    <ClickAwayListener
                        onClickAway={this.closePanel}
                        mouseEvent={openedPanel ? 'onClick' : false}
                        touchEvent={openedPanel ? 'onTouchEnd' : false}
                    >
                        <RowFlexContainer>
                            {this.renderChangeModePanel()}
                            {this.renderUserInfoPanel()}
                        </RowFlexContainer>
                    </ClickAwayListener>
                </AdminHeaderArea>
                <NatAdminMenuMasterComponentPc
                    {...this.props}
                />
            </AdminHeaderShadow>
        </>
    }
}

const Panel = styled.div<{
    $open: boolean,
    $width: string,
}>`
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: ${props => props.$width};

  position: absolute;
  top: ${ADMIN_HEADER_HEIGHT}px;
  right: 0;
  background-color: ${Colors.Surface};
  color: ${Colors.Body};
  overflow: hidden;
  ${AdminHeaderShadowCss};
  z-index: -1;

  ${(props) => props.$open ? `
    transition: all 0.5s;
    opacity: 1;
    visibility: visible;
  ` : `
    opacity: 0;
    visibility: hidden;
  `}
`

export default withAsyncCommunication(AdminHeaderAreaComponentPc)
